module.exports = __webpack_public_path__ + "static/img/pc_face.01c91983.png";